import React, { useRef, useState, useContext } from "react";
import { Link } from "react-router-dom";
// Components
import { Stack } from "@mui/material";
import MKTypography from "components/MKTypography";
import {
  StyledDropdownBox,
  StyledNavBox,
  StyledNavLink,
  StyledNavTitle,
  StyledCategoryList,
  StyledCategoryItem,
  StyledSubmenuArrow,
  StyledSubmenuList,
  StyledSubmenuItem,
  StyledSingleColumnItem,
} from "./index.styles";
import { DirectorySearchBar } from "utils/context/directorySearchBar.context";

const DesktopNavList = ({ routes }) => {
  const [hovered, setHovered] = useState(null);
  const [hoveredSubmenu, setHoveredSubmenu] = useState(null);
  const timerRef = useRef(null);
  const { setSearchTerms, setFilterOptions, setPage } = useContext(DirectorySearchBar);

  const handleMouseEnter = (index) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setHovered(index);
    setHoveredSubmenu(null); // Reset submenu when entering new top-level item
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setHovered(null);
      setHoveredSubmenu(null);
    }, 250);
  };

  const handleSubmenuEnter = (index) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setHoveredSubmenu(index);
  };

  const handleClick = (name) => {
    if (name === "Find A Therapist") {
      setFilterOptions([]);
      setSearchTerms("");
      setPage(1);
    }
    setHovered(null);
    setHoveredSubmenu(null);
  };

  return (
    <Stack direction={"row"}>
      {routes.map((item, index) => (
        <StyledNavBox key={item.name} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={handleMouseLeave}>
          <StyledNavLink variant="button" color="inherit" component={item.route ? Link : "span"} to={item.route || null}>
            <StyledNavTitle variant="button" fontWeight="regular" textTransform="capitalize">
              {item.name}
            </StyledNavTitle>
          </StyledNavLink>
          {item.collapse && (
            <StyledDropdownBox isVisible={hovered === index}>
              {item.collapse.some((cat) => cat.submenu) ? (
                // TWO-COLUMN LAYOUT for menus with submenus
                <Stack direction="row" gap={3}>
                  {/* LEFT SIDE - Category List */}
                  <StyledCategoryList hasSubmenu={hoveredSubmenu !== null && item.collapse[hoveredSubmenu]?.submenu} hoveredSubmenu={hoveredSubmenu}>
                    {item.collapse.map((category, catIndex) => (
                      <StyledCategoryItem
                        key={category.key}
                        isHovered={hoveredSubmenu === catIndex}
                        onMouseEnter={() => handleSubmenuEnter(catIndex)}
                        component={category.route && !category.submenu ? Link : "span"}
                        to={category.route && !category.submenu ? category.route : null}
                        onClick={() => !category.submenu && handleClick(category.name)}
                      >
                        <span>{category.name}</span>
                        {category.submenu && <StyledSubmenuArrow variant="body2">›</StyledSubmenuArrow>}
                      </StyledCategoryItem>
                    ))}
                  </StyledCategoryList>

                  {/* RIGHT SIDE - Submenu Items */}
                  {hoveredSubmenu !== null && item.collapse[hoveredSubmenu]?.submenu && (
                    <StyledSubmenuList>
                      {item.collapse[hoveredSubmenu].submenu.map((subItem) => (
                        <StyledSubmenuItem
                          key={subItem.key}
                          component={Link}
                          to={subItem.route}
                          onClick={() => handleClick(subItem.name)}
                          variant="body2"
                        >
                          {subItem.name}
                        </StyledSubmenuItem>
                      ))}
                    </StyledSubmenuList>
                  )}
                </Stack>
              ) : (
                // SINGLE COLUMN LAYOUT for regular dropdowns (no submenus)
                <Stack>
                  {item.collapse.map((category) => (
                    <StyledSingleColumnItem
                      key={category.key}
                      component={Link}
                      to={category.route}
                      onClick={() => handleClick(category.name)}
                      variant="button"
                      py={0.625}
                      px={2}
                      textTransform="capitalize"
                    >
                      <MKTypography variant="body2">{category.name}</MKTypography>
                    </StyledSingleColumnItem>
                  ))}
                </Stack>
              )}
            </StyledDropdownBox>
          )}
        </StyledNavBox>
      ))}
    </Stack>
  );
};

export default DesktopNavList;
